<template>
  <div class="order" style="padding-bottom: 60px">
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">收货地址</p>
      </div>
    </header>

    <!--<div style="padding: 0 1rem">-->
      <!--<div class="harvesDiv" >-->
        <!--<div class="adressDiv">-->
          <!--<p><span class="default">默认</span>北京市朝阳区</p>-->
          <!--<p><van-icon name="edit" /></p>-->
        <!--</div>-->
        <!--<p class="adress">李海龙</p>-->
        <!--<p class="name"><span></span><span style="margin-left: 2rem"></span></p>-->
      <!--</div>-->
    <!--</div>-->
    <div style="padding: 0 1rem">
      <!--<div class="harvesDiv" v-for="(item,index) in list" @click="goOrder(item.id)">-->
      <div class="harvesDiv" v-for="(item,index) in list" @click="saveDefaultAddress(item.id)">
        <div class="adressDiv">
          <p>
            <span v-if="item.is_default==1" class="default">默认</span>
            <span>{{item.province_name}}{{item.city_name}}{{item.county_name}}</span></p>
          <p @click.stop="tomodifyAddress(item.id)"><van-icon name="edit" /></p>
        </div>
        <p class="adress">
          <span>{{item.address}}</span>
          <!--<span>{{item}}</span>-->
          <span style="display: flex"><span style="font-size: 12px">默认地址</span><van-switch  v-model="item.checked" active-color="#ee0a24" @click="saveDefaultAddress(item.id)" inactive-color="#dcdee0" size="15px" /></span>
        </p>
        <p class="name"><span>{{item.name}}</span><span style="margin-left: 2rem">{{item.tel}}</span></p>
      </div>
    </div>

    <div class="inforName">
      <van-button style="width: 100%;height:3rem;margin:  auto" color="red" type="primary" @click="saveCart">+新建收货地址</van-button>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        list:[],
        checked:true,
        arr:{"checked":false},
        formPath:""
      }
    },
    created(){

    },
    beforeRouteEnter (to, from, next){
      next(vm=>{
        vm.formPath=from.path
      })
      if(from.path=="/orderPage"){
//         localStorage.setItem("sendId",this.$route.query.id)
      }
    },
    methods: {
      backHistory(){
        this.$router.go(-1)
//       if(this.formPath=="/orderPage"){  //地址页返回订单也传参
//         this.$router.push({
//           path:"/orderPage",
//           query:{
//             id:this.$route.query.id
//           }
//         })
//       }else {
//         this.$router.push({
//           path:"/myShop"
//         })
//       }
      },
      goOrder(id){
        console.log(this.$route.query)
        this.$api.saveDefaultAddress({
          user_id:localStorage.getItem("userid"),
          id:id
        }).then(res=>{
//          this.selectAddress()
        })
        this.$router.replace({
          path:"/orderPage",
          query:{
            id:this.$route.query.id,
            goodid:this.$route.query.goodid,
            spec_id:this.$route.query.spec_id,
            stock:this.$route.query.stock,
            ref:this.$route.query.ref
          }
        })
      },
      tomodifyAddress(id){
//        stopPropagation()
//        e.preventDefault()
        this.$router.replace({
          path:"/modifyAddress",
          query:{
            id:id
        }
        })
      },
      saveCart(){
        this.$router.replace({
          path:"/newAddress",
          query:{
            id:this.$route.query.id,
            goodid:this.$route.query.goodid,
            spec_id:this.$route.query.spec_id,
            stock:this.$route.query.stock,
            ref:this.$route.query.ref
          }
        })
//        this.$router.push("/newAddress")
      },
      selectAddress(){
       this.$api.selectAddress({
         user_id:localStorage.getItem("userid")
        }).then(res=>{
         this.list=res.data
         this.list.forEach(item=>{
           if(item.is_default==1){
             this.$set(item, 'checked', true)
           }else {
             this.$set(item, 'checked',false)
           }
         })
        })

      },
      saveDefaultAddress(id){
        this.$dialog.alert({
          title: '是否设为默认地址地址',
          message: '',
          showCancelButton:true
        }).then(() => {
          this.$api.saveDefaultAddress({
            user_id:localStorage.getItem("userid"),
            id:id
          }).then(res=>{
            this.selectAddress()
          })
        });
      }
    },
    mounted(){
      this.selectAddress()
      this.$nextTick(()=>{
        // 验证是否获取到了上页的url
        /* eslint-disable no-console */
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  header{
    width: 100%;
    height: 50px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
  .order{
    width: 100%;
    height: 100%;
    /*background: #E4E4E4;*/
    padding-top: 70px;
    font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Microsoft Yahei',sans-serif;

  }
  .inforName{
    position: fixed;
    bottom: 5px;
    width: 100%;
    display: flex;
  }
  .default{
   background: red;
    color: #ffffff;
    padding: 2px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 5px;
  }
  .adress{
    font-weight: 700;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
  }
  .name{
    color: #6d6d72;
    font-size: 14px;
  }
  .adressDiv{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .harvesDiv{
    margin-top: 1rem;

  }
</style>



// WEBPACK FOOTER //
// src/components/shop/harvestAddress.vue